(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('AuditsController', AuditsController);

    /* @ngInject */
    function AuditsController($filter, $state, ParseLinks, AlertService, pagingParams, paginationConstants, AuditsService) {
        var vm = this;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.query = {
            filter: '',
            limit: paginationConstants.itemsPerPage,
            order: '-id',
            page: 1
        };

        function loadAll() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                fromDate: fromDate,
                toDate: toDate
            }, function(result, headers) {
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
            });
        }

        // Date picker configuration
        function today() {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth() {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }
            vm.fromDate = fromDate;
        }

        function transition() {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            vm.promise = AuditsService.query({
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                fromDate: fromDate,
                toDate: toDate
            }).$promise;

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.audits = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.refresh();
        }

        vm.today();
        vm.previousMonth();
        vm.loadAll();
    }
})();
